import { Registry } from "@Core/registry";
import { Kernel } from "@Core/kernel";

// Theme-Kontext (niedrigere Prio)
//Registry.setContext({ prioBase: 10, source: "theme" });

// Theme-Komponenten importieren:
//import "./components/Footer/component.js";
// Kernel zum Schluss booten
new Kernel().boot();